export default function useYmTriggers() {
	const runtimeConfig = useRuntimeConfig();

	function reachGoal(value: string) {
		const YM = (window as typeof window & { ym: Function })?.ym;
		if (YM) {
			YM(runtimeConfig.public.YM_ID, 'reachGoal', value);
		}
	}

	return {
		reachGoal,
	};
}
